import { useEffect } from "react";
import { ONETRACK_DOMAIN, ONETRACK_WORKSPACE_ID } from "../../utils/onetrack/secrets";
import { init } from "../../utils/onetrack/onetrack-sdk";
import { NODE_ENV } from "../../utils/secrets";

const OneTrackHelper = () => {
    useEffect(() => {
        const initializeOneTrack = async () => {
            const workspaceId = ONETRACK_WORKSPACE_ID;
            const domain = ONETRACK_DOMAIN;

            if (NODE_ENV === "production" && workspaceId && domain) {
                init(workspaceId, domain);
                console.log("OneTrack SDK Initialized (dynamically)");
            } else {
                console.warn("OneTrack SDK environment variables not set. Skipping initialization.");
            }
        };

        initializeOneTrack().catch(err => console.error("Failed to initialize OneTrack SDK:", err));
    }, []);

    return <div id={"one-track-helper"} />;
};

export default OneTrackHelper;
